<template>
	<div>
		<div class="row">
			<div class="input-field col s6 m6 l3 xl3">
				<input id="peso" name="peso" type="number" class="validate" v-model='this.peso' min='0.0' max='9.9' step='0.1' required>
				<label for="peso">Nome</label>
			</div>
		</div>
		
		<div class="row">	
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn"><i class="material-icons left">save</i>Salvar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
      name: "VueAvalPesoForm",
      props: [
        'peso',
      ],
      data () {
        return {

        }
      },
    }
</script>
